// extracted by mini-css-extract-plugin
export default {"list":"styles_list__3dIyg","item":"styles_item__meRRi"};